import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import guid from '@/shared/utils/guid';
import messages from '../invoiceStreamMessages';

export default class UpdateInvoiceStreamMergeWithModal extends Component {
  state = {
    templates: [],
    mergeWithTemplateId: null,
    selection: '',
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { intl } = this.props;
    api.base.get(`${config.appUrls.api}/api/AssignmentTemplate/get`).then(({ data }) => {
      const templates = (data || [])
        .map(t => ({
          ...t,
          code: t.code || '',
          label: `${t.code ? `${t.code} – ` : ''}${intl.formatMessage(
            listItemMsg('assignmenttemplate', t.id, t.name),
          )}`,
        }))
        .sort(dynamicSortMultiple('code', 'label'));
      this.setState({ templates });
    });
  }

  handleChange = e => {
    const { value } = e.target;
    this.setState({
      selection: value,
      mergeWithTemplateId: value === '' ? null : value,
    });
  };

  onSave = () => {
    const { onSave } = this.props;
    const { mergeWithTemplateId } = this.state;
    return onSave({ mergeWithTemplateId });
  };

  render() {
    const { show, onClose, intl } = this.props;
    const { templates, selection } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.UpdateMergeWith)}
        show={show}
        onClose={onClose}
        onSave={this.onSave}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.MergeWith} />
            </label>
            <div className="col-sm-7">
              <select className="form-control" value={selection} onChange={this.handleChange}>
                <option value="">{intl.formatMessage(messages.DoNotMerge)}</option>
                <option value={guid.empty}>{intl.formatMessage(messages.DefaultAssignment)}</option>
                {templates
                  .filter(t => !t.mergeWithAssignmentTemplateId)
                  .map(t => (
                    <option key={t.id} value={t.id}>
                      {t.label}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
